export default __webpack_public_path__ + "static/media/const2.5ad71d19.jpg";